












import Vue from "vue";
import AufstellungElementComp from "./AufstellungElementComp.vue";

export default Vue.extend({
	name: "AufstellungBodyComp",
	components: { AufstellungElementComp },
	props: ["aufstellung", "showExtraRoles"],
});
